// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-discount-container {
  overflow: auto;
}
.add-discount-container .listing-header {
  display: flex;
  place-content: center;
  align-items: center;
  padding: 0.0625rem 0 1.875rem 0;
}
.add-discount-container .listing-header .title-div {
  font-size: 1.75rem;
  font-weight: bold;
  color: var(--ion-color-primary-black);
  text-transform: capitalize;
}

.justify-end {
  justify-content: flex-end;
}

.justify-start {
  justify-content: flex-start;
}

.add-discount-container {
  padding: 1.5rem 1.875rem 1.5rem 1.875rem;
  overflow: auto;
}
.add-discount-container .heading-label {
  font-size: 1.125rem;
  font-weight: bold;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}
.add-discount-container .form-container .form-inputs {
  padding-bottom: 0.75rem;
}
.add-discount-container .form-container .form-inputs ion-item .country-code {
  display: none;
}
.add-discount-container .form-container .form-inputs ion-item.item-has-value .country-code,
.add-discount-container .form-container .form-inputs ion-item.item-has-focus .country-code {
  display: flex;
}
.add-discount-container .form-container .form-inputs ion-label {
  letter-spacing: 0 !important;
  color: var(--ion-color-secondary-black) !important;
  text-transform: uppercase !important;
  opacity: 1 !important;
  font-size: 0.75rem !important;
}

ion-select {
  width: 100%;
  font-size: 1rem;
  font-weight: 600;
}

.company-address-div {
  width: 49.2%;
}

.company-address-class {
  display: flex;
  place-content: space-between;
}

ion-input,
ion-item {
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
  font-size: 1rem;
  line-height: 1.3125rem;
}

ion-list {
  padding: 0;
}

.text-left {
  right: 0 !important;
  left: unset !important;
}

.text-right {
  left: 0 !important;
  right: unset !important;
}

ion-select.LTR::part(icon) {
  opacity: 1;
  color: transparent;
  margin-left: 1rem;
  background: url('down-arrow-dark.1fb8e5fc34077de6.svg') no-repeat center;
}

ion-select.RTL::part(icon) {
  opacity: 1;
  color: transparent;
  margin-right: 1rem;
  background: url('down-arrow-dark.1fb8e5fc34077de6.svg') no-repeat center;
}

.arabic-label {
  direction: ltr !important;
  text-align: right !important;
}

.arabic-select::part(placeholder) {
  direction: ltr;
  text-align: right;
}

.date-div {
  align-items: center;
}

.add-discount-div .listing-header {
  display: flex;
  justify-content: space-between;
  padding: 0.3125rem 0 1.5625rem 0;
}
.add-discount-div .listing-header .title-div {
  font-size: 1.75rem;
  font-weight: bold;
  color: var(--ion-color-primary-black);
  text-transform: capitalize;
}
.add-discount-div .listing-table {
  margin: 0 0 1.25rem 0px;
  overflow-x: auto;
  max-height: 55vh;
}
.add-discount-div .listing-table .table {
  width: 100%;
}
.add-discount-div .listing-table .table .column-heading {
  font-weight: 500;
  font-size: 0.975rem;
  line-height: 0.975rem;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  padding: 0.75rem 0.5625rem 0.75rem 0;
}
.add-discount-div .listing-table .table .checkbox-col {
  min-width: 60px;
}
.add-discount-div .listing-table .table .ship-to-col {
  min-width: 100px;
  max-width: 244px;
}
.add-discount-div .listing-table .table .product-id {
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}
.add-discount-div .listing-table .table .table-body {
  font-size: 1rem;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}
.add-discount-div .listing-table .table .table-body .table-row {
  border-bottom: 1px solid var(--ion-color-primary-border);
}
.add-discount-div .listing-table .table .table-body .table-row td {
  padding: 0.4375rem 0.5625rem 0.1875rem 0;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.375rem;
  color: var(--ion-color-primary-black);
}
.add-discount-div .listing-table .table .table-body .table-row .right-arrow {
  display: flex;
  align-items: center;
}

.justify-end {
  justify-content: flex-end;
}

.justify-start {
  justify-content: flex-start;
}

.id-col {
  min-width: 90px;
}

.name-col {
  min-width: 135px;
}

.qty-col {
  min-width: 70px;
}

.qty-sold-col {
  min-width: 80px;
}

.price-col {
  min-width: 60px;
}

.sku-col {
  min-width: 75px;
}

.uploaded-time-col {
  min-width: 120px;
}

.edit-col {
  min-width: 60px;
}

.edit-img-icon {
  cursor: pointer;
}

.search-icon {
  align-self: center;
  margin: 0.25rem 2.625rem 0 0;
  cursor: pointer;
}

.product-checkbox {
  --opacity: 1;
  --border-color: var(--ion-color-primary-border);
  --border-width: 1px;
}

.thead {
  border-bottom: 1px solid var(--ion-color-primary-border);
  font-size: 0.75rem;
  font-weight: bold;
  letter-spacing: 0;
  color: var(--ion-color-secondary-black);
  text-transform: uppercase;
  opacity: 1;
}

th {
  padding: 0.9375rem 0 1.25rem 0;
}

ion-select::part(icon) {
  opacity: 1;
  margin-left: 1rem;
  color: transparent;
  background: url('down-arrow-dark.1fb8e5fc34077de6.svg') no-repeat center;
}

.add-discount-div {
  padding: 0 0.3125rem 0 0;
}

.profile-bottom-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.profile-bottom-container .cancel {
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  padding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;
  cursor: pointer;
}
.profile-bottom-container .cancel:hover {
  font-weight: 600;
}
.profile-bottom-container .profile-button ion-button {
  --background: var(--ion-color-primary);
  width: 100px;
  height: 46px;
  font-weight: 600;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  --box-shadow: none;
  --border-radius: 0;
}

.close-div {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  width: 100%;
  top: 0.3125rem;
}
.close-div .close-icon {
  cursor: pointer;
  max-width: 40px;
}

::-webkit-scrollbar {
  width: 0.625rem;
}

.product-name {
  font-size: 1.5rem;
  color: var(--ion-color-primary-black);
  text-transform: capitalize;
}
.product-name span {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/components/return-cancel-status/return-cancel-status.component.scss"],"names":[],"mappings":"AAAA;EACC,cAAA;AACD;AACC;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,+BAAA;AACF;AACE;EACC,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,0BAAA;AACH;;AAIA;EACC,yBAAA;AADD;;AAIA;EACC,2BAAA;AADD;;AAIA;EACC,wCAAA;EACA,cAAA;AADD;AAGC;EACC,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AADF;AAKE;EACC,uBAAA;AAHH;AAMI;EACC,aAAA;AAJL;AAUI;;EACC,aAAA;AAPL;AAWG;EACC,4BAAA;EACA,kDAAA;EACA,oCAAA;EACA,qBAAA;EACA,6BAAA;AATJ;;AAeA;EACC,WAAA;EACA,eAAA;EACA,gBAAA;AAZD;;AAeA;EACC,YAAA;AAZD;;AAeA;EACC,aAAA;EACA,4BAAA;AAZD;;AAeA;;EAEC,iBAAA;EACA,qCAAA;EACA,UAAA;EACA,eAAA;EACA,sBAAA;AAZD;;AAeA;EACC,UAAA;AAZD;;AAeA;EACC,mBAAA;EACA,sBAAA;AAZD;;AAeA;EACC,kBAAA;EACA,uBAAA;AAZD;;AAeA;EACC,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,wEAAA;AAZD;;AAeA;EACC,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,wEAAA;AAZD;;AAeA;EACC,yBAAA;EACA,4BAAA;AAZD;;AAeA;EACC,cAAA;EACA,iBAAA;AAZD;;AAeA;EACC,mBAAA;AAZD;;AAgBC;EACC,aAAA;EACA,8BAAA;EACA,gCAAA;AAbF;AAeE;EACC,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,0BAAA;AAbH;AAiBC;EACC,uBAAA;EACA,gBAAA;EACA,gBAAA;AAfF;AAiBE;EACC,WAAA;AAfH;AAiBG;EACC,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uCAAA;EACA,oCAAA;AAfJ;AAkBG;EACC,eAAA;AAhBJ;AAmBG;EACC,gBAAA;EACA,gBAAA;AAjBJ;AAoBG;EACC,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AAlBJ;AAqBG;EACC,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AAnBJ;AAqBI;EACC,wDAAA;AAnBL;AAqBK;EACC,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,qCAAA;AAnBN;AAsBK;EACC,aAAA;EACA,mBAAA;AApBN;;AA6BA;EACC,yBAAA;AA1BD;;AA6BA;EACC,2BAAA;AA1BD;;AA6BA;EACC,eAAA;AA1BD;;AA6BA;EACC,gBAAA;AA1BD;;AA6BA;EACC,eAAA;AA1BD;;AA6BA;EACC,eAAA;AA1BD;;AA6BA;EACC,eAAA;AA1BD;;AA6BA;EACC,eAAA;AA1BD;;AA6BA;EACC,gBAAA;AA1BD;;AA6BA;EACC,eAAA;AA1BD;;AA6BA;EACC,eAAA;AA1BD;;AA6BA;EACC,kBAAA;EACA,4BAAA;EACA,eAAA;AA1BD;;AA6BA;EACC,YAAA;EACA,+CAAA;EACA,mBAAA;AA1BD;;AA6BA;EACC,wDAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,uCAAA;EACA,yBAAA;EACA,UAAA;AA1BD;;AA6BA;EACC,8BAAA;AA1BD;;AA6BA;EACC,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,wEAAA;AA1BD;;AA6BA;EAGC,wBAAA;AA5BD;;AA+BA;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;AA5BD;AA8BC;EACC,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uCAAA;EACA,gDAAA;EACA,eAAA;AA5BF;AA8BE;EACC,gBAAA;AA5BH;AAiCE;EACC,sCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AA/BH;;AAoCA;EACC,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AAjCD;AAmCC;EACC,eAAA;EACA,eAAA;AAjCF;;AAsCA;EACC,eAAA;AAnCD;;AAuCA;EACC,iBAAA;EACA,qCAAA;EACA,0BAAA;AApCD;AAsCC;EACC,iBAAA;AApCF","sourcesContent":[".add-discount-container {\n\toverflow: auto;\n\n\t.listing-header {\n\t\tdisplay: flex;\n\t\tplace-content: center;\n\t\talign-items: center;\n\t\tpadding: 0.0625rem 0 1.875rem 0;\n\n\t\t.title-div {\n\t\t\tfont-size: 1.75rem;\n\t\t\tfont-weight: bold;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\ttext-transform: capitalize\n\t\t}\n\t}\n}\n\n.justify-end {\n\tjustify-content: flex-end;\n}\n\n.justify-start {\n\tjustify-content: flex-start;\n}\n\n.add-discount-container {\n\tpadding: 1.5rem 1.875rem 1.5rem 1.875rem;\n\toverflow: auto;\n\n\t.heading-label {\n\t\tfont-size: 1.125rem;\n\t\tfont-weight: bold;\n\t\tletter-spacing: 0;\n\t\tcolor: var(--ion-color-primary-black);\n\t\topacity: 1;\n\t}\n\n\t.form-container {\n\t\t.form-inputs {\n\t\t\tpadding-bottom: 0.75rem;\n\n\t\t\tion-item {\n\t\t\t\t.country-code {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tion-item.item-has-value,\n\t\t\tion-item.item-has-focus {\n\t\t\t\t.country-code {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tion-label {\n\t\t\t\tletter-spacing: 0 !important;\n\t\t\t\tcolor: var(--ion-color-secondary-black) !important;\n\t\t\t\ttext-transform: uppercase !important;\n\t\t\t\topacity: 1 !important;\n\t\t\t\tfont-size: 0.75rem !important;\n\t\t\t}\n\t\t}\n\t}\n}\n\nion-select {\n\twidth: 100%;\n\tfont-size: 1rem;\n\tfont-weight: 600;\n}\n\n.company-address-div {\n\twidth: 49.2%;\n}\n\n.company-address-class {\n\tdisplay: flex;\n\tplace-content: space-between;\n}\n\nion-input,\nion-item {\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-primary-black);\n\topacity: 1;\n\tfont-size: 1rem;\n\tline-height: 1.3125rem;\n}\n\nion-list {\n\tpadding: 0;\n}\n\n.text-left {\n\tright: 0 !important;\n\tleft: unset !important;\n}\n\n.text-right {\n\tleft: 0 !important;\n\tright: unset !important;\n}\n\nion-select.LTR::part(icon) {\n\topacity: 1;\n\tcolor: transparent;\n\tmargin-left: 1rem;\n\tbackground: url('../../../assets/icon/down-arrow-dark.svg') no-repeat center;\n}\n\nion-select.RTL::part(icon) {\n\topacity: 1;\n\tcolor: transparent;\n\tmargin-right: 1rem;\n\tbackground: url('../../../assets/icon/down-arrow-dark.svg') no-repeat center;\n}\n\n.arabic-label {\n\tdirection: ltr !important;\n\ttext-align: right !important;\n}\n\n.arabic-select::part(placeholder) {\n\tdirection: ltr;\n\ttext-align: right;\n}\n\n.date-div {\n\talign-items: center;\n}\n\n.add-discount-div {\n\t.listing-header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding: 0.3125rem 0 1.5625rem 0;\n\n\t\t.title-div {\n\t\t\tfont-size: 1.75rem;\n\t\t\tfont-weight: bold;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\ttext-transform: capitalize\n\t\t}\n\t}\n\n\t.listing-table {\n\t\tmargin: 0 0 1.25rem 0px;\n\t\toverflow-x: auto;\n\t\tmax-height: 55vh;\n\n\t\t.table {\n\t\t\twidth: 100%;\n\n\t\t\t.column-heading {\n\t\t\t\tfont-weight: 500;\n\t\t\t\tfont-size: 0.975rem;\n\t\t\t\tline-height: 0.975rem;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tcolor: var(--ion-color-secondary-black);\n\t\t\t\tpadding: 0.75rem 0.5625rem 0.75rem 0;\n\t\t\t}\n\n\t\t\t.checkbox-col {\n\t\t\t\tmin-width: 60px;\n\t\t\t}\n\n\t\t\t.ship-to-col {\n\t\t\t\tmin-width: 100px;\n\t\t\t\tmax-width: 244px;\n\t\t\t}\n\n\t\t\t.product-id {\n\t\t\t\tfont-size: 1rem;\n\t\t\t\tfont-weight: bold;\n\t\t\t\tletter-spacing: 0;\n\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\topacity: 1;\n\t\t\t}\n\n\t\t\t.table-body {\n\t\t\t\tfont-size: 1rem;\n\t\t\t\tletter-spacing: 0;\n\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\topacity: 1;\n\n\t\t\t\t.table-row {\n\t\t\t\t\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\n\t\t\t\t\ttd {\n\t\t\t\t\t\tpadding: 0.4375rem 0.5625rem 0.1875rem 0;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\tline-height: 1.375rem;\n\t\t\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\t\t}\n\n\t\t\t\t\t.right-arrow {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t}\n\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.justify-end {\n\tjustify-content: flex-end;\n}\n\n.justify-start {\n\tjustify-content: flex-start;\n}\n\n.id-col {\n\tmin-width: 90px;\n}\n\n.name-col {\n\tmin-width: 135px;\n}\n\n.qty-col {\n\tmin-width: 70px;\n}\n\n.qty-sold-col {\n\tmin-width: 80px;\n}\n\n.price-col {\n\tmin-width: 60px;\n}\n\n.sku-col {\n\tmin-width: 75px;\n}\n\n.uploaded-time-col {\n\tmin-width: 120px;\n}\n\n.edit-col {\n\tmin-width: 60px;\n}\n\n.edit-img-icon {\n\tcursor: pointer;\n}\n\n.search-icon {\n\talign-self: center;\n\tmargin: 0.25rem 2.625rem 0 0;\n\tcursor: pointer;\n}\n\n.product-checkbox {\n\t--opacity: 1;\n\t--border-color: var(--ion-color-primary-border);\n\t--border-width: 1px;\n}\n\n.thead {\n\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\tfont-size: 0.75rem;\n\tfont-weight: bold;\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-secondary-black);\n\ttext-transform: uppercase;\n\topacity: 1;\n}\n\nth {\n\tpadding: 0.9375rem 0 1.25rem 0;\n}\n\nion-select::part(icon) {\n\topacity: 1;\n\tmargin-left: 1rem;\n\tcolor: transparent;\n\tbackground: url('../../../assets/icon/down-arrow-dark.svg') no-repeat center;\n}\n\n.add-discount-div {\n\t// overflow: auto;\n\t// max-height: 70%;\n\tpadding: 0 0.3125rem 0 0;\n}\n\n.profile-bottom-container {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\n\t.cancel {\n\t\tfont-weight: 400;\n\t\tfont-size: 0.9375rem;\n\t\tline-height: 1.125rem;\n\t\tletter-spacing: 0.4px;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-secondary-black);\n\t\tpadding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n\n\t.profile-button {\n\t\tion-button {\n\t\t\t--background: var(--ion-color-primary);\n\t\t\twidth: 100px;\n\t\t\theight: 46px;\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 0.9375rem;\n\t\t\tline-height: 1.125rem;\n\t\t\tletter-spacing: 0.4px;\n\t\t\t--box-shadow: none;\n\t\t\t--border-radius: 0;\n\t\t}\n\t}\n}\n\n.close-div {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tposition: absolute;\n\twidth: 100%;\n\ttop: 0.3125rem;\n\n\t.close-icon {\n\t\tcursor: pointer;\n\t\tmax-width: 40px;\n\t}\n\n}\n\n::-webkit-scrollbar {\n\twidth: 0.625rem;\n}\n\n\n.product-name {\n\tfont-size: 1.5rem;\n\tcolor: var(--ion-color-primary-black);\n\ttext-transform: capitalize;\n\n\tspan {\n\t\tfont-weight: bold;\n\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
